import { env } from "@/env";
export const getAvatarUrlFromAccountId = (accountId: string) => {
  return `${env.AVATAR_IMAGE_DOMAIN}/avatars/${accountId}.png`;
};
